<template>
  <div
    class="fe-flex fe-items-center fe-bg-primary-grey-20 fe-p-xs fe-rounded-medium fe-text-body-xs lg:fe-text-body-s fe-text-primary-grey-80"
  >
    <JdsIcon
      name="WarningIcon"
      size="m"
      color="fe-text-primary-50"
      className="fe-mr-xs"
    />
    {{ text }}
  </div>
</template>

<script>
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"

  export default {
    name: "EmptyQnA",
    components: {
      JdsIcon,
    },
    props: {
      text: {
        type: String,
        default: "",
      },
    },
  }
</script>
